<template>
    <div class="text-[#2b2b2b]">
        <div class="mb-4">
            <h2 class="text-4xl">Ajouter un objectif</h2>
        </div>

        <div class="p-4 text-[#2b2b2b] bg-white rounded-lg">
            <form @submit.prevent="addObjectif" class="mt-3 flex flex-col gap-y-10 w-full">
                    <div class="flex flex-col gap-y-1">
                        <label for="titre" class="font-extralight text-[16px]">Titre <span class="text-[red]">*</span></label>
                        <input type="text" v-model="form.title" placeholder="Titre" class="h-[40px] border rounded-lg p-3">
                    </div>

                    <div class="flex flex-col gap-y-1">
                        <label for="key_result" class="font-extralight text-[16px]">Résultat clé <span class="text-[red]">*</span></label>
                        <textarea v-model="form.keyresult" name="key_result" id="key_result" placeholder="1 - First key result" class="min-h-[150px] border rounded-lg p-3"></textarea>
                    </div>

                    <div class="flex flex-col gap-y-1">
                        <label for="key_action" class="font-extralight text-[16px]">Actions clés</label>
                        <textarea v-model="form.keyactions" name="key_action" id="key_action" placeholder="1 - First key action" class="min-h-[150px] border rounded-lg p-3"></textarea>
                    </div>

                    <div class="flex gap-x-3">
                        <div class="flex flex-col gap-y-1 grow">
                            <label for="obtype" class="font-light" >Type d'objectif<span class="text-[#f44545]">*</span></label>
                            <select v-model="form.type" name="obtype" id="obtype" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                                <option value="">Choisissez le type</option>
                                <option value="PERSONNEL">PERSONNEL</option>
                                <option value="COLLECTIF">COLLECTIF</option>
                                <option value="COLLABORATIF">COLLABORATIF</option>
                            </select>
                        </div>
                        <div class="flex gap-x-3 grow">
                            <div class="flex flex-col gap-y-1 grow">
                                <label for="debut" class="font-light" >Début<span class="text-[#f44545]">*</span></label>
                                <input v-model="form.start" type="date" name="debut" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                            </div>
                            <div class="flex flex-col gap-y-1 grow">
                                <label for="debut" class="font-light" >Fin<span class="text-[#f44545]">*</span></label>
                                <input v-model="form.end" type="date" name="debut" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                            </div>
                        </div>
                    </div>
                    
                    <button type="submit" class="text-white bg-[#3c41e9] rounded-lg h-[40px] w-full flex items-center justify-center">
                        <Loader2 v-if="asSend" class="animate-spin mx-auto"/>
                        <span v-if="!asSend">Ajouter un objectif</span>
                    </button>
            </form>
        </div>
    </div>
</template>
<script>
import API from '@/service/API';
import {
    Loader2
} from "lucide-vue-next";
import toast from '@/components/ui/toast';
export default {
    name : "CreateTaskView",
    components:{Loader2},
    props:[],
    data(){
        return {
            asSend:false,
            form:{
                title:"",
                keyresult:"",
                keyactions:"",
                type:"",
                start:null,
                end:null,
                user_id: localStorage.getItem("userId")
            }
        }
    },
    methods:{
        clearForm(){
            this.form = {
                title:"",
                keyresult:"",
                keyactions:"",
                type:"",
                start:null,
                end:null,
                user_id: localStorage.getItem("userId")
            }
        },
        addObjectif(){
            this.asSend = true;
            API.post("/goals",{
                title:this.form.title,
                key_results:this.form.keyresult,
                key_actions:this.form.keyactions,
                type:this.form.type,
                start:this.form.start,
                end:this.form.end,
                user_id:this.form.user_id
            })
            .then((data)=>{
                if(data.data["status"]){
                    toast.success("Succès","Objectif ajouté",3000);
                    this.clearForm();
                }else{
                    toast.error("Oops..",data.data["message"],4000);
                }
            })
            .catch(()=>{
                toast.error("Oops..","Il semble avoir une erreur, merci de réessayé.",4000);
            })
            .finally(()=>{this.asSend = false});
        },
    }
}
</script>